import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/footer/Footer.jsx';
import { setPageMetadata } from '../utils/seo.js';

function NotFoundPage() {
	useEffect(() => {
		setPageMetadata({
			title: '404 | CodingFlash',
			description: 'La pagina que buscas no esta disponible.',
			path: window.location.pathname,
			robots: 'noindex, follow',
		});
		window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
	}, []);

	return (
		<>
			<main className='flex min-h-screen items-center bg-[radial-gradient(circle_at_top,_rgba(255,255,255,0.08),_transparent_45%),linear-gradient(180deg,#050505_0%,#090909_100%)] px-6 pb-12 pt-28 text-primary lg:px-10'>
				<div className='mx-auto w-full max-w-3xl rounded-2xl border border-white/10 bg-white/[0.03] p-7 backdrop-blur sm:p-10'>
					<span className='inline-flex min-h-9 items-center rounded-full border border-white/15 px-4 text-[10px] font-bold uppercase tracking-[0.22em] text-primary/55'>
						Error de navegacion
					</span>

					<h1 className='title-readable mt-5 font-display text-5xl font-bold text-primary sm:text-6xl'>
						404
					</h1>
					<h2 className='title-readable mt-2 font-display text-2xl font-semibold text-primary sm:text-3xl'>
						Esta pagina no existe
					</h2>
					<p className='mt-4 max-w-2xl text-base leading-relaxed text-primary/75'>
						La URL que intentaste abrir no esta disponible o fue movida. Podes
						volver al inicio para seguir navegando.
					</p>

					<div className='mt-8 flex flex-wrap gap-3'>
						<Link
							to='/'
							className='inline-flex min-h-11 items-center rounded-full border border-white/15 px-5 text-sm text-primary/80 transition-colors hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/70'
						>
							Volver al inicio
						</Link>
						<Link
							to='/terminos'
							className='inline-flex min-h-11 items-center rounded-full border border-white/15 px-5 text-sm text-primary/70 transition-colors hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/70'
						>
							Ver terminos
						</Link>
					</div>
				</div>
			</main>

			<Footer />
		</>
	);
}

export default NotFoundPage;
